import * as React from 'react';
import { PagedListingState, BaseRouteProps } from '../../interfaces';
import { Organization, PagedData } from '../../models';
import { OrganizationDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { PagedDataGrid, PVAPage } from '../../components';
import { FilterStore, UserStore } from '../../stores';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';

interface OrganizationListingState extends PagedListingState<Organization> {
    open: boolean;
    viewLicensees: boolean;
    viewSubscriptions: boolean;
}

interface OrganizationProps extends BaseRouteProps<{}> {
    FilterStore?: FilterStore;
    UserStore?: UserStore;
    showDropDown: boolean;
}

@inject('FilterStore', 'UserStore') @observer
export class OrganizationListing extends React.Component<OrganizationProps, OrganizationListingState> {
    private organizationDataService = new OrganizationDataService(this.props.notificationService);
    private dataGrid: PagedDataGrid | null;

    constructor(props: OrganizationProps) {
        super(props);

        this.state = {
            entities: [],
            pageProperties: {
                currentPage: 1,
                pageSize: 20,
            },
            sortProperty: {
                id: 'Name',
                sortAscending: true
            },
            open: false,
            viewLicensees: false,
            viewSubscriptions: false
        };

        this.dataFunctionWrapper = this.dataFunctionWrapper.bind(this);
        // this.deleteBinder = this.deleteBinder.bind(this);
    }

    @computed get organization() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return this.props.FilterStore.organization;
        }
        return null;
    }

    getNewFilteredDataList = () => {
        if (this.dataGrid) {
            this.dataGrid.getData();
        }
    }

    private dataFunctionWrapper(page: number, newPage: number, pageSize: number, filter?: string, sortProperty?: string, sortDirection?: string) {
        const { viewLicensees, viewSubscriptions } = this.state;
    
        return this.organizationDataService.getAllPaged(page, pageSize, filter, sortProperty, sortDirection, viewLicensees, viewSubscriptions).then((response: PagedData<Organization>) => {
            this.updateState(newPage, response);
        });
    }

    private updateState(pageNumber: number, data: PagedData<any>) {
        this.setState({
            entities: data.entities,
            pageProperties: Object.assign(
                {},
                this.state.pageProperties,
                {
                    currentPage: pageNumber,
                    recordCount: data.recordCount
                }
            )
        });
    }

    private exportExpiring() {
        this.organizationDataService.getExpiringCSV();
    }

    private exportExpired() {
        this.organizationDataService.getExpiredCSV();
    }

    private ActionsButton() {
        return (
            <div className="btn-group dropdown">
                <button type="button" className="btn btn-primary"  onClick={(e) => this.setState({open: !this.state.open })}>
                    <span>Actions </span>
                    <span className="caret" />
                </button>
                <ul className={`action-menu dropdown-menu ${this.state.open ? 'open' : ''}`}>
                    <li className="options-header">Actions</li>
                    <li className="options-entry" onClick={(e) => this.props.history.push('/organization/create')}>
                        <div className="options-entry-title">
                            <span className="glyphicon glyphicon-plus" /> <span> Create</span>
                        </div>
                        <div className="options-entry-desc">
                            Create a new organization
                        </div>
                    </li>
                    <li className="options-header">Filter Options</li>
                    {(this.state.viewLicensees || this.state.viewSubscriptions) &&
                        <li className="options-entry" onClick={() => this.setState({ viewLicensees: false, viewSubscriptions: false}, this.getNewFilteredDataList)}>
                            <div className="options-entry-title">
                                <span className="glyphicon glyphicon-list-alt" /> <span> View All</span>
                            </div>
                        </li>
                    }
                    {!this.state.viewLicensees &&
                        <li className="options-entry" onClick={(e) => this.setState({ viewLicensees: true, viewSubscriptions: false}, this.getNewFilteredDataList)}>
                            <div className="options-entry-title">
                                <span className="glyphicon glyphicon-filter" /> <span> View Licensees</span>
                            </div>
                        </li>
                    }
                    {!this.state.viewSubscriptions &&
                        <li className="options-entry" onClick={(e) => this.setState({ viewSubscriptions: true, viewLicensees: false}, this.getNewFilteredDataList)}>
                            <div className="options-entry-title">
                                <span className="glyphicon glyphicon-filter" /> <span> View Subscriptions</span>
                            </div>
                        </li>
                    }
                    <li className="options-header">Export Options</li>
                    <li className="options-entry" onClick={(e) => this.exportExpiring()}>
                        <div className="options-entry-title">
                            <img src="/images/Icon awesome-file-pdf.svg" /> <span> Expiring</span>
                        </div>
                        <div className="options-entry-desc">
                            Export organizations whose access is expiring in the next 60 days.
                        </div>
                    </li>
                    <li className="options-entry" onClick={(e) => this.exportExpired()}>
                        <div className="options-entry-title">
                            <img src="/images/Icon awesome-file-pdf.svg" /> <span> Expired</span>
                        </div>
                        <div className="options-entry-desc">
                            Export organizations whose access to the system has expired.
                        </div>
                    </li>
                </ul>
        </div>);
    }

    public render() {
        const { sortProperty, pageProperties, entities } = this.state;

        const listData = entities.map(entity => {
            return {
                'Name': entity.name,
                'ActionKey': entity.id
            };
        });

        const actionsColumn = ({ value }: any) => {
            return (
                <span>
                    <NavLink to={`/Organization/${value}`} className="btn btn-default">View</NavLink>
                </span>
            );
        };

        const columnDefs = [
            { id: 'Name' },
            { id: 'ActionKey', title: 'Actions', width: '88px', customComponent: actionsColumn, sortable: false }
        ];

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        Organizations
                    </PVAPage.Header.Title>
                    <PVAPage.Header.Buttons>
                        {this.organization && <NavLink to={`/Organization/${this.organization.id}`} className="btn btn-default">View {this.organization.name}</NavLink>}
                        {this.ActionsButton()}
                    </PVAPage.Header.Buttons>
                </PVAPage.Header>
                <PVAPage.Body>
                    {this.state.viewLicensees && <h3>Organizations with Licenses</h3>}
                    {this.state.viewSubscriptions && <h3>Organizations with Subscriptions</h3>}
                    <PagedDataGrid  
                        ref={el => this.dataGrid = el}
                        entities={listData}
                        columns={columnDefs}
                        dataFunction={this.dataFunctionWrapper}
                        defaultSort={sortProperty}
                        pageProperties={pageProperties}
                    />
                </PVAPage.Body>
                <PVAPage.Footer />
            </PVAPage>);
    }
}


// WEBPACK FOOTER //
// ./src/components/organization/OrganizationListing.tsx